import { type ReactElement, type ReactNode } from "react";
import { Text } from "@citibox-panel/ui";

// Shared layout scaffolding for the UI-Kit showcase: a titled <section> (its h5
// heading is what the tests query) and a wrap-flex row. Imported by UiKitPage
// and by the individual demo files.
export function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactElement {
  return (
    <section style={{ marginBottom: 48 }}>
      <Text variant="h5" component="h2" gutterBottom>
        {title}
      </Text>
      {children}
    </section>
  );
}

export function Row({ children }: { children: ReactNode }): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      {children}
    </div>
  );
}
